// Components
import { setupPopup } from './components/Popup.js'
import { setupScrolledPage } from './components/ScrolledPage.js'

// Sections
// import { setupTermsConditionsDetails } from './sections/terms-conditions-details.js'

document.addEventListener('DOMContentLoaded', () => {
  // Sections
  // setupTermsConditionsDetails()
  
  // Components
  setupPopup()
  setupScrolledPage()
})